import { render, staticRenderFns } from "./TutorTalk.vue?vue&type=template&id=1dbcc33c&scoped=true&"
import script from "./TutorTalk.vue?vue&type=script&lang=js&"
export * from "./TutorTalk.vue?vue&type=script&lang=js&"
import style0 from "./TutorTalk.vue?vue&type=style&index=0&id=1dbcc33c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbcc33c",
  null
  
)

export default component.exports